/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-env es6 */

async function getSvgImageFromUrl(http, url) {
  try {
    const response = await http.get(`https:${url}`);

    if (response.headers.get('content-type') === 'image/svg+xml') {
      return await response.text();
    }
  } catch (error) {
    console.warn(error);
  }
  return null;
}

export const state = () => ({
  obrazki: [],
  pendingRequests: [],
});

export const getters = {
  getImage: (state) => (url) => state.obrazki.find((ob) => ob.url === url),
  checkIfPending: (state) => (url) => state.pendingRequests.find((ob) => ob === url),
};

export const mutations = {
  setImage(state, image) {
    if (image && image.url && image.svg) {
      state.obrazki.push(image);
    }
  },
  setLoadingImage(state, imageUrl) {
    if (imageUrl) {
      state.pendingRequests.push(imageUrl);
    }
  },
  setLoadedImage(state, imageUrl) {
    if (imageUrl) {
      const index = state.pendingRequests.findIndex((url) => url === imageUrl);

      if (index >= 0) state.pendingRequests.splice(index, 1);
    }
  },
};

export const actions = {
  async fetchImage({ commit, getters }, url) {
    try {
      const image = { url, svg: '' };
      const alreadyLoading = getters.checkIfPending(url);

      if (!alreadyLoading) {
        commit('setLoadingImage', url);
        const svg = await getSvgImageFromUrl(this.$http, url);

        image.svg = svg;
        image.url = url;
        commit('setImage', image);
        commit('setLoadedImage', url);
      }
    } catch (err) {
      console.error(err);
      commit('setLoadedImage', url);
    }
  },
};
